import { render, staticRenderFns } from "./NewmoonSidebar.vue?vue&type=template&id=365b21ea"
import script from "./NewmoonSidebar.vue?vue&type=script&lang=js"
export * from "./NewmoonSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewmoonSidebar.vue?vue&type=style&index=0&id=365b21ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports